import { useMemo } from "react"
import { ResolvedTable, resolveTable } from "../../model/resolve"
import { useTabSpecStore } from "../../runtime/tabSpecStore"
import type { Catalogue } from "../../types/catalogue"
import type { TableSpec, TabSpecDocument } from "../../types/tabSpecDocument"

/** Resolves tables before the questionnaire is in: every question reads as unknown. */
const EMPTY_CATALOGUE: Catalogue = {
  questions: [],
  knownPaths: null,
  hasRouting: false,
}

export interface InspectedTable {
  table: TableSpec
  resolved: ResolvedTable
  document: TabSpecDocument
  /** The question catalogue, or an empty one while the questionnaire loads. */
  catalogue: Catalogue
  /** False while the questionnaire loads. */
  loaded: boolean
}

/** The table the inspector shows, with its defaults filled in; null once it is gone. */
export const useInspectedTable = (tableId: string): InspectedTable | null => {
  const document = useTabSpecStore((s) => s.document)
  const catalogue = useTabSpecStore((s) => s.catalogue)
  return useMemo(() => {
    const table = document.tables.find((t) => t.id === tableId)
    if (!table) return null
    const known = catalogue ?? EMPTY_CATALOGUE
    return {
      table,
      resolved: resolveTable(table, document, known),
      document,
      catalogue: known,
      loaded: catalogue !== null,
    }
  }, [document, catalogue, tableId])
}
